// import components
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material';

export const StyledGridContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(4),
  gap: theme.spacing(4)
}));

export const StyledGridFullWidth = styled(Grid)(() => ({
  width: '100%'
}));
